module.exports = __webpack_public_path__ + "img/1.1.fa1e13ed.jpg";